import SFXLoadingComponent from "components/SFXLoadingComponent";
import React from "react";

export default class StepLoadingComponent extends React.Component {
    render() {
        return <div style={{
            margin: "40px"
        }}>
            <SFXLoadingComponent
                message={this.props.message}
                style={{margin: "auto"}}
                color={this.props.color !== undefined ? this.props.color : "#00A6FF"}
            />
        </div>
    }
}